import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthUserService} from '../../core/services/auth-user.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.component.html',
    styleUrls: ['./auth-callback.component.css']
})
export class AuthCallbackComponent implements OnInit, OnDestroy {
    constructor(private authService: AuthUserService) {}

    ngOnInit() {
        Swal.fire('Loading');
        Swal.showLoading();
        if (this.authService.isAuthenticated()) {
            this.authService.navigateToStoredOrDefault();
            return;
        }
        this.authService.handleMicrosoftRedirect();
    }

    ngOnDestroy() {
        Swal.close();
    }
}